import {
  Button,
  Checkbox,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Typography
} from "@material-tailwind/react";
import React, {useContext, useEffect, useState} from "react";
import Dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {getServiceAgentBranchDiscount} from "../../services/branch_discount/agent_branch_discount";
import {getUserWallet} from "../../services/payment/payment";
import {ceil, parseInt} from "lodash";
import {getBranchCommissionServiceVat} from "../../services/branch_commission/branch_commission";
import {updateServicePayment} from "../../services/service/service";
import {ServiceContext} from "./service_context";

export function InvoiceForm() {

  const {
    service,
    branchInfo,
    modalOpen,
    setModalOpen,
    setStep,
    setLastDataRefresh,
    setChargeAmount,
    setChargeDiscountCode,
    chargeDiscountCode
  } = useContext(ServiceContext);


  const handleOpen = () => setModalOpen(!modalOpen);

  const [priceAfterDiscount, setPriceAfterDiscount] = useState(null);
  const [vat, setVat] = useState(null);
  const [branchVatPercentage, setBranchVatPercentage] = useState(null);


  const [wallet, setWallet] = useState({});
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    setVat(ceil(priceAfterDiscount * branchVatPercentage / 100));
  }, [priceAfterDiscount, branchVatPercentage]);

  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    setTotalPrice(priceAfterDiscount + vat)
  }, [vat]);

  const [discount, setDisCount] = useState(false)
  const [discountCode, setDisCountCode] = useState("")

  async function handleDiscountCode() {
    const result = await getServiceAgentBranchDiscount(service.branch_id, discountCode);
    if (result.status === 200) {
      const {branch_discount} = result.data;
      if ((service.price * (100 - parseInt(branch_discount.percentage)) / 100) >= parseInt(branch_discount.value)) {
        setPriceAfterDiscount(service.price - parseInt(branch_discount.value));
      } else {
        setPriceAfterDiscount(service.price * (100 - branch_discount.percentage) / 100)
      }
      setDisCount(true)
    } else {
      setPriceAfterDiscount(service.price)
      setDisCount(false)
    }
  }

  async function handleChargeDiscountCode() {
    const result = await getServiceAgentBranchDiscount(service.branch_id, chargeDiscountCode);
    if (result.status === 200) {
      const {branch_discount} = result.data;
      if ((service.price * (100 - parseInt(branch_discount.percentage)) / 100) >= parseInt(branch_discount.value)) {
        setPriceAfterDiscount(service.price - parseInt(branch_discount.value));
      } else {
        setPriceAfterDiscount(service.price * (100 - branch_discount.percentage) / 100)
      }
      setDisCount(true)
    } else {
      setPriceAfterDiscount(service.price)
      setDisCount(false)
    }
  }

  useEffect(() => {
    setPriceAfterDiscount(service.price);

    async function getWalletData(agentBranchFeeId) {
      const wallet_result = await getUserWallet();
      if (wallet_result.status === 200) {
        const {user_wallet} = wallet_result.data;
        setWallet(user_wallet || {});
        setBalance(user_wallet?.balance ?? 0)
      }
      const vat_result = await getBranchCommissionServiceVat(service.agent_id, service.branch_id)
      if (vat_result.status === 200) {
        const {agent_branch_vat} = vat_result.data;
        setBranchVatPercentage(agent_branch_vat);
      }

      if (chargeDiscountCode && chargeDiscountCode.length > 0) {
        setDisCountCode(chargeDiscountCode)
        handleChargeDiscountCode();
      }
    }

    getWalletData()
  }, []);

  const save_payment = async () => {
    const data = {
      id: service.id,
      agent_id: service.agent_id,
      branch_id: service.branch_id,
      person_id: service.person_id,
      service_price: priceAfterDiscount,
      service_vat: vat,
      discount_code: discountCode
    };

    let result;

    result = await updateServicePayment(data);

    if (result.status === 202) {
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  const save = (tag) => {
    if (tag === 'return') {
      setStep("check")
    } else if (tag === 'payment') {
      if (priceAfterDiscount + vat <= balance) {
        save_payment()
      }
    }
  };

  return (
    <>
      <Dialog size="xl" open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
              className="max-h-screen bg-none">
        <DialogHeader className="bg-gray-800 rounded-t-2xl -mt-4">
          <Typography className="py-4 w-full text-white text-2xl z-10 textCenter">
            پیش‌فاکتور
          </Typography>
        </DialogHeader>

        <DialogBody className="flex flex-col gap-4 rounded-2xl overflow-y-scroll max-h-[530px] md:max-h-screen">

          <div className="flex flex-row border-b-2 mb-2">
            <Typography className="flex flex-col ml-2">
              {`${Dict('agent')}: `}
            </Typography>
            <Typography className="flex flex-col" color="blue-gray">
              {service.agent_name}
            </Typography>
          </div>

          <div className="flex flex-row border-b-2 mb-2">
            <Typography className="flex flex-col ml-2">
              {`${Dict('branch_title')}: `}
            </Typography>
            <Typography className="flex flex-col" color="blue-gray">
              {branchInfo.branch_title}
            </Typography>
          </div>

          {branchInfo.side_cost &&
            <>
              <Checkbox
                checked={branchInfo.side_cost}
                label={
                  <Typography color="blue-gray" className="flex font-medium">
                    هزینه‌های جانبی
                  </Typography>
                }
              />
              <div className="mb-4 flex flex-col pb-2 border-b-2">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2 mb-4">
                    {Dict('side_cost_description') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {branchInfo.side_cost_description}
                  </Typography>
                </div>
                <div className="flex flex-row">
                </div>
              </div>
            </>
          }

          <div className="mb-4 pb-2 border-b-2">
            <div className="flex flex-row">
              <Typography className="flex flex-col ml-2">
                {Dict('service_day') + ": "}
              </Typography>
              <Typography className="flex flex-col" color="blue-gray">
                {persianNumberFormat(service.day, true) + " روز"}
              </Typography>
            </div>
          </div>

          <div className="mb-4 pb-2 border-b-2">
            <div className="flex flex-row">
              <Typography className="flex flex-col ml-2">
                {Dict('total_service_price') + ": "}
              </Typography>
              <Typography className="flex flex-col" color="blue-gray">
                {persianNumberFormat(service.price, true) + " ریال"}
              </Typography>
            </div>
          </div>

          <div className="relative flex flex-row mb-4 max-w-full mx-2">
            <Input variant="standard"
                   className="flex flex-col w-1/2"
                   value={discountCode}
                   label={Dict('discount_code')}
                   placeholder={Dict('discount_code')}
                   onChange={(e) => {
                     setDisCountCode(e.target.value);
                   }}
            />
            <Button variant="outlined" size="sm" color="gray" onClick={handleDiscountCode}
                    className="!absolute left-1 top-1 rounded text-center">
              اعمال کدتخفیف
            </Button>
          </div>

          {discount &&
            <>
              <div className="mb-4 pb-2 border-b-2">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2">
                    {Dict('discount') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(service.price - priceAfterDiscount, true) + " ریال"}
                  </Typography>
                </div>
              </div>

              <div className="mb-4 pb-2 border-b-2">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2">
                    {Dict('after_discount') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(priceAfterDiscount, true) + " ریال"}
                  </Typography>
                </div>
              </div>
            </>
          }

          <div className="mb-4 pb-2 border-b-2">
            <div className="flex flex-row">
              <Typography className="flex flex-col ml-2">
                {persianNumberFormat(branchVatPercentage) + "% " + "ارزش افزوده: "}
              </Typography>
              <Typography className="flex flex-col" color="blue-gray">
                {persianNumberFormat(vat, true) + " ریال"}
              </Typography>
            </div>
          </div>

          <div className="mb-4 pb-2 border-b-2">
            <div className="flex flex-row">
              <Typography className="flex flex-col ml-2">
                {Dict('total_price') + ": "}
              </Typography>
              <Typography className="flex flex-col" color="blue-gray">
                {persianNumberFormat(totalPrice, true) + " ریال"}
              </Typography>
            </div>
          </div>


        </DialogBody>

        <DialogFooter className="space-x-2 justify-between bg-gray-800 rounded-b-2xl -mb-4">
          <div className="flex flex-row right-0">
            <Typography className="flex flex-col" color="white">
              {Dict('balance') + ": "}
            </Typography>
            <Typography className="flex flex-col" color="white">
              {persianNumberFormat(balance, true) + " ریال"}
            </Typography>
          </div>
          <div className=" flex flex-row mt-4 left-0 md:mt-0">
            <Button variant="text" color="white" onClick={() => {
              save('return')
            }}>
              <span>بازگشت</span>
            </Button>
            {totalPrice <= balance &&
              <Button variant="gradient" color="gray" onClick={() => {
                save('payment')
              }} className="ml-1">
                <span>پرداخت از کیف پول</span>
              </Button>
            }
            {totalPrice > balance &&
              <Button variant="gradient" color="white" size="sm md:lg" onClick={() => {
                setChargeAmount(totalPrice - balance)
                setChargeDiscountCode(discountCode)
                setStep("charge_wallet")
              }} className="ml-1">
                <span>شارژ کیف پول</span>
              </Button>
            }
          </div>
        </DialogFooter>
      </Dialog>
    </>
  );
}
